import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border-2 rounded border-current" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_ContentTextEditor = _resolveComponent("ContentTextEditor")!
  const _component_BaseStyle = _resolveComponent("BaseStyle")!
  const _component_Content = _resolveComponent("Content")!

  return (_ctx.fileUpload.fileCache.value)
    ? (_openBlock(), _createBlock(_component_BaseStyle, {
        key: 0,
        "content-style": new _ctx.Style({}),
        class: "content-base"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["base-checkbox flex select-none space-x-2 items-center", [
          'justify-center',
        ]])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "flex justify-center items-center",
                style: _normalizeStyle({
              height: `${_ctx.checkboxSize}px`,
              width: `${_ctx.checkboxSize}px`
            })
              }, [
                _createVNode(_component_BaseIcon, {
                  variant: 'default',
                  size: _ctx.checkboxSize,
                  icon: 'check'
                }, null, 8, ["size"])
              ], 4)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_ContentTextEditor, {
                "content-style": _ctx.contentTextEditor.style,
                "connect-actions": _ctx.contentTextEditor.connectActions,
                html: _ctx.contentTextEditor.text
              }, null, 8, ["content-style", "connect-actions", "html"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["content-style"]))
    : (_openBlock(), _createBlock(_component_Content, {
        key: 1,
        content: _ctx.contents[0]
      }, null, 8, ["content"]))
}